import {throwIfUndefined} from '@coolcolduk/util';
import {Study} from '@cp/model';
import getStudyDoc from './getStudyDoc';

export default async function getStudyDocValidated(moduleId: string, topic: string): Promise<Study> {
  return throwIfUndefined(await getStudyDoc(moduleId, topic), 'Study not found');
}
